import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Request } from "@core/models/requests.model";
import { CredentialsPhone } from '@modules/configuration-ia/interfaces/bot-ia/voices/credentials-phone.interface';
import { VoiceAccents, ListVoice, VoiceTones } from '@modules/configuration-ia/interfaces/bot-ia/voices/list-voice.interface';
import { SimpleResponse } from '@shared/interfaces/simple-response.interface';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VoiceSettingsService {

  private configUser: any = undefined;
  private url = 'configuracionia';
  private URLQA3: string = 'https://qa3.sicopweb.com/api/v1/';
  public isSavingVoice: boolean = false;

  constructor(
    private request: Request,
    private http: HttpClient,
  ) { 
    this.setConfigUser();
  }

  public addVoiceSettings(idBotIa: string, credentialsVoice: any, voiceIa: any ) {
    
    const body = {
      idBot: idBotIa,
      iaVoz: voiceIa,
      credencialVoz: credentialsVoice,
      configuracion: {
        ...this.configUser,
      }
    };
    
    return this.request.Post<SimpleResponse>(`${this.url}/add-voice`, body);
  }

  public validateCredentialsNumber(number: string){
    return this.http.get<CredentialsPhone[]>(`${this.URLQA3}catalogos/getDataTelefono?telefono=${number}`)
    .pipe(take(1));
  }

  public getListVoices(){
    return this.request.Get<ListVoice>(`documentos/search/audio`);
  }

  public getListTones(){
    return this.request.Get<VoiceTones>(`${this.url}/iavoz/iavoztono/list`);
  }
  public getListAccents(){
    return this.request.Get<VoiceAccents>(`${this.url}/iavoz/iavozacento/list`);
  }

  public setConfigUser(){
    this.configUser = this.request.getConfigUser();
  }
}
